import React, {useEffect} from "react";
import Card from "../../../../components/Card";
import IconButton from "../../../../components/IconButton";
import {faEdit, faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import Text from "../../../../components/Text";
import {Font} from "../../../../types/Font";
import cx from 'classnames'
import styles from './FontCard.module.css'

const FontCard: React.FC<Font & {
    openEditModal: (font: Font) => void
    openDeleteModal: (font: Font) => void
}> = ({id, name, path, active, openEditModal, openDeleteModal}) => {

    useEffect(() => {
        if (!name || !path) return

        const fontFace = new FontFace(name, `url(${path})`)
        fontFace.load().then((f) => {
            document.fonts.add(f)
        })
    }, [name, path])

    return (
        <Card>
            <>
                <div className={cx(styles['card-wrapper'])}>
                    <IconButton
                        icon={faEdit}
                        color={'#2f2f2f'}
                        onClick={() => openEditModal({id, name, path, active})}
                    />
                    <IconButton
                        icon={faTrashAlt}
                        color={'#2f2f2f'}
                        onClick={() => openDeleteModal({id, name, path, active})}
                    />
                </div>
                <div className={cx(styles['card-inner-wrapper'])}>
                    <div className={cx(styles['font-family-wrapper'])} style={{fontFamily: name}}>
                        Aa
                    </div>
                    <Text>{name}</Text>
                </div>
            </>
        </Card>
    )
}

export default FontCard
